import { defineMessages } from 'react-intl'

const scope = 'app.components.ActionsModal'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage:
      '{mode, select, create {Create a new} edit {Edit} delete {Delete} other {}} {type}{mode, select, view {: {itemName}} other {}}',
  },
  deleteHint: {
    id: `${scope}.deleteHint`,
    defaultMessage: 'Are you sure you want to delete the {type} {itemName}?',
  },
  actions: {
    cancel: {
      id: `${scope}.actions.cancel`,
      defaultMessage: 'Cancel',
    },
    submit: {
      id: `${scope}.actions.submit`,
      defaultMessage: 'Submit',
    },
  },
})
